import { z as o } from "zod";
const n = o.object({
  src: o.string(),
  title: o.string().optional(),
  mask: o.boolean().optional()
});
export {
  n as iconInfoSchema
};
